import { keyAdvice, keyAnswer, mayHaveActed, problemDetail, problemText, sameKeySameAnswer } from '@/shared/api'

/**
 * Что окно платежа говорит об отказе записи — и жива ли «Записать».
 *
 * Ответ ключа без пояснения сервера — своим советом (`keyAdvice`): погашенная кнопка обязана назвать
 * причину. Сбой сети и 5xx без типа ключа — исход неизвестен: платёж мог лечь, но тот же ключ второй
 * раз его не запишет. Без этих слов менеджер закрыл бы окно и записал заново — уже с новым ключом.
 */
export function paymentFailure(error: unknown): { title: string; advice: string | null; stuck: boolean } {
  if (mayHaveActed(error) && !keyAnswer(error)) {
    return {
      title: 'Не знаем, записан ли платёж',
      advice: 'Нажмите «Записать» ещё раз: второй раз он не запишется.',
      stuck: false,
    }
  }
  return {
    title: problemText(error, 'Не удалось записать платёж'),
    advice: problemDetail(error) ?? keyAdvice(error),
    stuck: sameKeySameAnswer(error),
  }
}
